/**
 * Listing counts per category_id — supabase.rpc(get_category_listing_counts).
 */
import { createClient } from "@/lib/supabase/client";

export async function fetchCategoryListingCountsRpc(): Promise<Record<string, number>> {
  const supabase = createClient();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await supabase.rpc("get_category_listing_counts" as any);
  if (error) throw error;
  if (data == null || typeof data !== "object") return {};
  const out: Record<string, number> = {};
  for (const [k, v] of Object.entries(data as Record<string, unknown>)) {
    const n = Number(v);
    if (!Number.isNaN(n)) out[k] = n;
  }
  return out;
}
